import { ADD_NEW_SITE_SUCCESS, UPDATE_NEW_SITE_SUCCESS, SITE_DATA_ERROR, SITES_LIST_SUCCESS, SITE_DATA_SUCCESS, DRAWING_DATA_SUCCESS, ALL_SITE_DATA_SUCCESS, DELETE_SITE_BYID, DELETE_SITE_SUCCESS, DELETE_SITE_ERROR,
   GETALLSITES, DRAWING_DATA_ERROR ,CHANGEREQUEST_BY_SITEID_SUCCESS,ADD_CHANGEREQUEST_SUCCESS,SITEDROPDOWN_LIST_SUCCESS} from "./actiontype"


const initialState = {
  newSite: null,
  updateSite: null,
  sitelist: [],
  drawinglist: [],
  loading: false,
  error: null,
  totalCount: 0,
}

const getsiteData = (state = initialState, action) => {
  switch (action.type) {
    case SITE_DATA_SUCCESS:
      state = {
        ...state,
        sitelist: action.payload.clientSiteRequests || [],
        totalCount:action.payload.totalCount,
        userlistError: null,
      }
      break;
    case ALL_SITE_DATA_SUCCESS:
      state = {
        ...state,
        allsiteslist: action.payload,
        sitelistError: null,
      }
      break;
      case SITEDROPDOWN_LIST_SUCCESS:
      state = {
        ...state,
        sitelistdropdown: action.payload.clientSiteRequests,
        sitelistError: null,
      }
      break;
      
    case SITES_LIST_SUCCESS:
      state = {
        ...state,
        getSite: action.payload || [],
        userlistError: null,
      }
      break;

    case GETALLSITES:
      state = {
        ...state,
        getallsite: action.payload,
        userlistError: null,
      }
      break;
    case SITE_DATA_ERROR:
      state = { ...state, sitelistError: action.payload }
      break;
    case ADD_NEW_SITE_SUCCESS:
      state = { ...state, newSite: action.payload }
      break;
    case UPDATE_NEW_SITE_SUCCESS:
      state = { ...state, updateSite: action.payload }
      break;
    case DELETE_SITE_BYID:
      state = {
        ...state, loading: false,
      };
      break;
    case DELETE_SITE_SUCCESS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_SITE_ERROR:
      state = { ...state, siteDeleted: false, loading: false };
      break;
    case DRAWING_DATA_SUCCESS:
      state = {
        ...state,
        drawinglist: action.payload.drawingGetRequest,
        totalCount:action.payload.totalCount,
        drawinglistError: null,
      }
      break;
    case DRAWING_DATA_ERROR:
      state = { ...state, drawinglisterror: action.payload }
      break;
    case CHANGEREQUEST_BY_SITEID_SUCCESS:
      state = {
        ...state,
        changerequestlist: action.payload.getChangeRequest,
        totalCount: action.payload.totalCount,
        changerequestError: null,
      }
      break;
      case ADD_CHANGEREQUEST_SUCCESS:
      return { 
        ...state, 
        newChangeRequest: action.payload 
      };

    default:
      state = { ...state };
      break;
  }
  return state
}

export default getsiteData
